import { call, select, put, takeLatest, all } from "redux-saga/effects";
import api from "../../Environment";
import {
  FETCH_WITHDRAWALS_START,
  SEND_WITHDRAW_REQUEST_START,
  CANCEL_WITHDRAW_REQUEST_START,
  FETCH_SINGLE_WITHDRAWALS_START,
  SEARCH_WITHDRAWALS_START,
  FETCH_REVERSED_USER_WITHDRAWAL_START,
} from "../actions/ActionConstant";

import { createNotification } from "react-redux-notify";
import {
  getSuccessNotificationMessage,
  getErrorNotificationMessage,
} from "../../components/helper/NotificationMessage";

import {
  fetchWithDrawalsSuccess,
  fetchWithDrawalsFailure,
  sendWithDrawRequestSuccess,
  sendWithDrawRequestFailure,
  cancelWithDrawRequestSuccess,
  cancelWithDrawRequestFailure,
  fetchSingleWithDrawalsSuccess,
  fetchSingleWithDrawalsFailure,
  searchWithDrawalsSuccess,
  searchWithDrawalsFailure,
  fetchWithDrawalsStart,
  fetchReversedUserWithdrawalSuccess,
  fetchReversedUserWithdrawalFailure
} from "../actions/WithDrawAction";
import { fetchWalletDetailsStart } from "../actions/WalletAction";
import UserPaymentService from "../../helpers/services/payment/user";
import { showErrorComponent } from "../actions/ComponentAction";

function* fetchWithDrawAPI() {
  try {
    const response = yield api.postMethod("withdrawals_index");

    if (response.data.success) {
      yield put(fetchWithDrawalsSuccess(response.data.data));
    } else {
      yield put(fetchWithDrawalsFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchWithDrawalsFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* sendWithDrawRequestAPI() {
  try {
    const inputData = yield select(
      (state) => state.withDraw.sendWithDraw.inputData
    );
    const response = yield api.postMethod(
      "withdrawals_send_request",
      inputData
    );

    if (response.data.success) {
      yield put(sendWithDrawRequestSuccess(response.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
      yield put(fetchWithDrawalsStart());
      yield put(fetchWalletDetailsStart());
    } else {
      yield put(sendWithDrawRequestFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(sendWithDrawRequestFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* cancelWithDrawRequestAPI() {
  try {
    const inputData = yield select(
      (state) => state.withDraw.cancelWithDraw.inputData
    );
    const response = yield api.postMethod(
      "withdrawals_cancel_request",
      inputData
    );

    if (response.data.success) {
      yield put(cancelWithDrawRequestSuccess(response.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
      yield put(fetchWithDrawalsStart());
    } else {
      yield put(cancelWithDrawRequestFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(cancelWithDrawRequestFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchSingleWithDrawAPI() {
  try {
    const inputData = yield select(
      (state) => state.withDraw.singleWithDraw.inputData
    );
    const response = yield api.postMethod("withdrawals_view", inputData);

    if (response.data.success) {
      yield put(fetchSingleWithDrawalsSuccess(response.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
    } else {
      yield put(fetchSingleWithDrawalsFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(fetchSingleWithDrawalsFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* searchWithDrawAPI() {
  try {
    const inputData = yield select(
      (state) => state.withDraw.searchWithDraw.inputData
    );
    const response = yield api.postMethod("withdrawals_search", inputData);

    if (response.data.success) {
      yield put(searchWithDrawalsSuccess(response.data));
      const notificationMessage = getSuccessNotificationMessage(
        response.data.message
      );
      yield put(createNotification(notificationMessage));
    } else {
      yield put(searchWithDrawalsFailure(response.data.error));
      const notificationMessage = getErrorNotificationMessage(
        response.data.error
      );
      yield put(createNotification(notificationMessage));
    }
  } catch (error) {
    yield put(searchWithDrawalsFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message);
    yield put(createNotification(notificationMessage));
  }
}

function* fetchRevertedUserWithdrawals() {
  try {
    const response = yield UserPaymentService.fetchRevertedUserWithdrawal();
    yield put(fetchReversedUserWithdrawalSuccess(response));
  } catch (error) {
    yield put(fetchReversedUserWithdrawalFailure(error));
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
  }
}
export default function* pageSaga() {
  yield all([yield takeLatest(FETCH_WITHDRAWALS_START, fetchWithDrawAPI)]);
  yield all([
    yield takeLatest(SEND_WITHDRAW_REQUEST_START, sendWithDrawRequestAPI),
  ]);
  yield all([
    yield takeLatest(CANCEL_WITHDRAW_REQUEST_START, cancelWithDrawRequestAPI),
  ]);
  yield all([
    yield takeLatest(FETCH_SINGLE_WITHDRAWALS_START, fetchSingleWithDrawAPI),
  ]);
  yield all([yield takeLatest(SEARCH_WITHDRAWALS_START, searchWithDrawAPI)]);
  yield takeLatest(FETCH_REVERSED_USER_WITHDRAWAL_START, fetchRevertedUserWithdrawals);
}
